import { render, staticRenderFns } from "./IndexReminder.vue?vue&type=template&id=3f17408e&scoped=true"
import script from "./IndexReminder.vue?vue&type=script&lang=js"
export * from "./IndexReminder.vue?vue&type=script&lang=js"
import style0 from "./IndexReminder.vue?vue&type=style&index=0&id=3f17408e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f17408e",
  null
  
)

export default component.exports